import React from 'react';
import PropTypes from 'prop-types';


const AudioPlayer = ({fileId, fileName}) => {

    const allowedExtensions = ['.wav', '.ogg', '.flac', '.aac', '.m4a', '.webm', '.mp3', '.aiff', '.caf'];

    const fileExtension = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
    const downloadUrl = `/thread/download-file/${fileId}`;

    if (!allowedExtensions.includes(fileExtension)) {
        return null;
    }

    return (
        <div>
            <figure className={"audio-file"}>
                <audio controls src={downloadUrl}>
                    Your browser does not support the audio element.
                </audio>
            </figure>
        </div>
    );
};

AudioPlayer.propTypes = {
    fileId: PropTypes.number.isRequired,
    fileName: PropTypes.string.isRequired,
};
export default AudioPlayer;